module.exports = __webpack_public_path__ + "img/cc-visa.48e5c0d7.png";